module.exports = __webpack_public_path__ + "img/rules_19.a14d7c9f.png";